module.exports = __webpack_public_path__ + "static/bg-apply-9df675ecc2f968bb783600f8a5bd6cf7.png";